import { Navigate } from "react-router-dom";



//Region
import EditRegion from "pages/Region/EditRegion";
import AddRegion from "../pages/Region/AddRegion";
import Region from "../pages/Region/Region";

//Form
import AddForm from "../pages/Form/add-form";
import Collaterals from "../pages/Form/collaterals";
import EditCollaterals from "../pages/Form/edit-collaterals";
import EditForm from "../pages/Form/edit-form";
import Form from "../pages/Form/form";

// Authentication related pages
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// Inner Authentication
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Register1 from "../pages/AuthenticationInner/Register";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Dashboard
import Dashboard from "../pages/Dashboard/Dashboard";

//Product
import EditProduct from "pages/Products/EditProduct";
import AddProduct from "../pages/Products/AddProduct";
import Products from "../pages/Products/products";

// Maps
import AddAddress from "../pages/Address/AddAddress";
import AddressListing from "../pages/Address/AddressListing";
import EditAddress from "../pages/Address/EditAddress";

//Icons

import EditDesignation from "pages/Designations/EditDesignation";
import AddDesignation from "../pages/Designations/AddDesignation";
import Designations from "../pages/Designations/designations";

//Employees
import AddEmployees from "pages/Employees/AddEmployee";
import Employees from "../pages/Employees/employees";


//Order
import EditOrder from "pages/Orders/EditOrders";
import AddOrder from "../pages/Orders/AddOrder";
import Order from "../pages/Orders/Order";

// Forms
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormElements from "../pages/Forms/FormElements";
import FormUpload from "../pages/Forms/FormUpload";
import FormValidations from "../pages/Forms/FormValidations";

//RegionalManager
import AddCollaterals from "pages/Form/add-collaterals";
import AddRegionalManager from "pages/Regional Managers/AddRegionalManager";
import EditRegionalManager from "pages/Regional Managers/EditRegionalManager";
import RegionalManager from "pages/Regional Managers/RegionalManagers";
import EditEmployee from "pages/Employees/EditEmployee";
import AllRegionReports from "pages/Reports/AllRegionReports";
import ProductReports from "pages/Reports/ProductReports";
import BudgetReports from "pages/Reports/BudgetReports";
import AddVisicooler from "pages/Visicoolers/AddVisicooler";
import EditVisicooler from "pages/Visicoolers/EditVisicooler";
import Visicoolers from "pages/Visicoolers/Visicoolers";


const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },


  //employees
  { path: "/employee-listing", component: <Employees /> },
  { path: "/add-employee", component: <AddEmployees /> },
  { path: "/edit-employee/:id", component: <EditEmployee /> },

  // form
  { path: "/form", component: <Form /> },
  { path: "/collaterals", component: <Collaterals /> },
  { path: "/add-form", component: <AddForm /> },
  { path: "/add-collaterals", component: <AddCollaterals /> },
  { path: "/edit-form/:id", component: <EditForm /> },
  { path: "/edit-collaterals/:id", component: <EditCollaterals /> },

  // Product
  { path: "/products", component: <Products /> },
  { path: "/add-product", component: <AddProduct /> },
  { path: "/edit-products/:id", component: <EditProduct /> },


  // Icons
  { path: "/designations", component: <Designations /> },
  { path: "/add-designation", component: <AddDesignation /> },

  { path: "/edit-designation/:id", component: <EditDesignation /> },

  //  Order
  { path: "/orders", component: <Order /> },
  { path: "/add-order", component: <AddOrder /> },
  { path: "/edit-order/:id", component: <EditOrder /> },

  //  Address
  { path: "/edit-address/:addressId", component: <EditAddress /> },
  { path: "/address-listing", component: <AddressListing /> },
  { path: "/add-address", component: <AddAddress /> },

  // // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-validation", component: <FormValidations /> },

  //Region

  { path: "/region-listing", component: <Region /> },
  { path: "/add-region", component: <AddRegion /> },
  { path: "/edit-region/:regionId", component: <EditRegion /> },

  // Regional Managers

  { path: "/regional-managers", component: <RegionalManager /> },
  { path: "/edit-regional-manager/:regionalManagerId", component: <EditRegionalManager /> },
  { path: "/add-regional-manager", component: <AddRegionalManager /> },

  // Reports
  { path: "/all-region-reports", component: <AllRegionReports /> },
  { path: "/product-reports", component: <ProductReports /> },
  { path: "/budget-reports", component: <BudgetReports /> },

  // Visicoolers
  { path: "/visicoolers", component: <Visicoolers /> },
  { path: "/add-visicooler", component: <AddVisicooler /> },
  { path: "/edit-visicooler/:visicoolerId", component: <EditVisicooler /> },


  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },


  // Authentication Inner
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { authRoutes, userRoutes };

